import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IUsers } from "./routeType";

const { key, getPath } = getApi("users.get");

type IExtractedRouteType = IUsers["userSingleRetrieve"];

export type IGetUsers = IPickSingleQuery<IExtractedRouteType>;

const getUser: Fetcher<IGetUsers["response"], IGetUsers["variables"]> = ({
  userId,
  ...params
}) => {
  return axiosClient.get(getPath({ userId }), { params });
};

export const useGetUser = createQuery({
  queryKey: [key],
  fetcher: getUser,
});
